import { Box, Divider } from "@mui/material"
import SearchSection from "../components/SearchWithNewsSection"
// import { SearchSection } from "../components/SearchSection"
import HomeContentSection from "../components/HomeContentSection"

export const HomePage = () => {
    const plh = `Scrivi qui il nome dell'applicazione o del contenuto che vuoi cercare...`
    //const user = useUser()
    
    // console.log('process.env.REACT_APP_CAROUSEL', process.env.REACT_APP_CAROUSEL)
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
            {/* process.env.REACT_APP_CAROUSEL === '1' /*&& user?.role === 'azienda' || true ? */} 
            <SearchSection placeholer={plh} />
            <Divider />
            <HomeContentSection />
        </Box>
    )
}

export default HomePage
